import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SEOHead from '../components/seo/SEOHead';
import Hero from '../components/landing/Hero';
import AboutSection from '../components/landing/AboutSection';
import FeaturedVideoSection from '../components/landing/FeaturedVideoSection';
import PhilosophySection from '../components/landing/PhilosophySection';
import ProjectsSection from '../components/landing/ProjectsSection';
import StrategySection from '../components/landing/StrategySection';
import FocusAreasSection from '../components/landing/FocusAreasSection';
import SuccessfulPilotsSection from '../components/landing/SuccessfulPilotsSection';
import OpenInnovationSection from '../components/landing/OpenInnovationSection';
import OperationalExcellenceSection from '../components/landing/OperationalExcellenceSection';
import ShakersSection from '../components/landing/ShakersSection';
import GrantsSection from '../components/landing/GrantsSection';
import ProjectsPortfolioSection from '../components/landing/ProjectsPortfolioSection';
import TeamSection from '../components/landing/TeamSection';
import ChallengesSection from '../components/landing/ChallengesSection';
import InnovationProcessSection from '../components/landing/InnovationProcessSection';
import InnovationVehiclesSection from '../components/landing/InnovationVehiclesSection';
import InnovationFrameworkSection from '../components/landing/InnovationFrameworkSection';
import PartnersSection from '../components/landing/PartnersSection';
import ContactForm from '../components/landing/ContactForm';
import { isEnglishPath } from '../utils/i18nRoutes';

const SEO_TEXT = {
  es: {
    title: 'Valoriza Innovation Hub | IA y tecnología en servicios urbanos',
    description: 'Hub de innovación de Valoriza. TrisTrash, Pando y tecnología que opera en la calle: residuos, limpieza y ciudades más seguras.',
  },
  en: {
    title: 'Valoriza Innovation Hub | AI and technology for urban services',
    description: 'Valoriza\u2019s innovation hub. TrisTrash, Pando and technology that operates on the street: waste, cleaning and safer cities.',
  },
};

const ALTERNATES = [
  { hreflang: 'es', href: '/' },
  { hreflang: 'en', href: '/en' },
  { hreflang: 'x-default', href: '/' },
];

export default function HomePage() {
  const location = useLocation();
  const locale = isEnglishPath(location.pathname) ? 'en' : 'es';
  const seo = SEO_TEXT[locale];

  const WEBSITE_JSON_LD = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Valoriza Innovation Hub',
    url: 'https://innovation.valorizasm.com',
    inLanguage: locale,
    publisher: { '@id': 'https://innovation.valorizasm.com/#organization' },
  };

  // Support cross-page navigation to home anchors, e.g. Link to="/#contacto"
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 120);
      }
    }
  }, [location]);

  return (
    <>
      <SEOHead
        title={seo.title}
        description={seo.description}
        path={locale === 'en' ? '/en' : '/'}
        locale={locale}
        alternates={ALTERNATES}
        jsonLd={[WEBSITE_JSON_LD]}
      />

      {/* 1 — Hero: full-screen video + liquid glass */}
      <Hero />
      {/* 2 — About: who Valoriza is */}
      <AboutSection />
      {/* 3 — Featured video: operations showcase */}
      <FeaturedVideoSection />
      {/* 4 — Philosophy: Innovation × Impact */}
      <PhilosophySection />
      {/* 5 — Projects: technology showcase (id="proyectos") */}
      <ProjectsSection />
      {/* 6 — Strategy: vision, pillars, objectives */}
      <StrategySection />
      {/* 6.5 — Focus Areas 2026 */}
      <FocusAreasSection />
      {/* 7 — Successful Pilots: TrisTrash & Lixo */}
      <SuccessfulPilotsSection />
      {/* 8 — Open Innovation */}
      <OpenInnovationSection />
      {/* 9 — Operational Excellence */}
      <OperationalExcellenceSection />
      {/* 10 — Shakers */}
      <ShakersSection />
      {/* 11 — Grants */}
      <GrantsSection />
      {/* 11.5 — Projects Portfolio */}
      <ProjectsPortfolioSection />
      {/* 12 — Team */}
      <TeamSection />
      {/* 13 — Challenges */}
      <ChallengesSection />
      {/* 13.5 — Innovation Process */}
      <InnovationProcessSection />
      {/* 13.6 — Innovation Vehicles */}
      <InnovationVehiclesSection />
      {/* 13.7 — Innovation Framework */}
      <InnovationFrameworkSection />
      {/* 14 — Partners */}
      <PartnersSection />
      {/* 15 — Contact */}
      <ContactForm />
    </>
  );
}
